module.exports = "/images/label_empty.png?f846d505b2055035433f75b3b3ff50db";